module.exports = __webpack_public_path__ + "static/media/premierOneLeftSeatMobileTaken.40e7090c.svg";